import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useDistribution } from '../../../../hooks/Distribution';
import { CloseIcon } from '../../../../components/icons';
import { Button, ImageHandler } from '../../../../components';
import { ShareDistributionRecipient } from '../index';
import { Container, Content, BalanceContainer, BalanceExhibitor, BalanceAmount, BalanceContent } from './styles';

type Props = {
    isBalance: boolean;
    resetDistributionLayout: () => void;
}

const CompleteDistribution: React.FC<Props> = ({ isBalance, resetDistributionLayout }) => {
    const navigate = useNavigate();
    const { exhibitor, voucherType, distributedAmount, createdRecipients, clearDistributionState } = useDistribution();

    if (!exhibitor || !voucherType)
        return <Navigate to={isBalance ? "/balance" : "/home"} replace />

    return (
        <Container>
            <Content>
                <CloseIcon
                    style={{ cursor: "pointer", marginLeft: "auto", paddingLeft: "30px" }}
                    id="distribution.closebutton"
                    onClick={() => {
                        clearDistributionState(false);
                        navigate(isBalance ? '/balance' : '/home', {
                            replace: true
                        });
                    }} />
                <h1>Feito!</h1>
                <h4>
                    Você acaba de distribuir <span>{distributedAmount}</span> {distributedAmount > 1 ? 'cortesias' : 'cortesia'}.
                </h4>
                <h6>
                    {distributedAmount > 1 ?
                        `As cortesias foram enviadas por e-mail ${createdRecipients.length > 1 ? 'aos destinatários' : 'ao destinatário'}`
                        : 'A cortesia foi enviada por e-mail ao destinatário.'
                    }
                </h6>
                <ShareDistributionRecipient />
                <BalanceContainer>
                    <span>Saldo de cortesias:</span>
                    <BalanceContent>
                        <BalanceExhibitor>
                            <ImageHandler
                                url={exhibitor.logo}
                                alt={exhibitor.name}
                            />
                            <div>
                                <strong>{exhibitor.name}</strong>
                                <small>{voucherType.name}</small>
                            </div>
                        </BalanceExhibitor>
                        <BalanceAmount>
                            <div>
                                <span>{voucherType.amount}</span>
                                <small>cortesias<br />anteriormente</small>
                            </div>
                            <div>
                                <span>{distributedAmount}</span>
                                <small>cortesias<br />distribuídas</small>
                            </div>
                            <div>
                                <span>{voucherType.amount - distributedAmount}</span>
                                <small>cortesias<br />disponíveis</small>
                            </div>
                        </BalanceAmount>
                    </BalanceContent>
                </BalanceContainer>
                <Button
                    id="distribution.newbutton"
                    onClick={() => {
                        clearDistributionState(true);
                        resetDistributionLayout();
                    }}
                >
                    Nova distribuição
                </Button>
            </Content>
        </Container>
    );
};

export { CompleteDistribution };
